/**
 * Monta a URL do arquivo do manual do avaliador a partir do prefixo do environment.
 * Aceita string (HML/PRD) ou URL (.dev) e garante barra antes do filename.
 */
export function buildEvaluatorManualUrl(
  urlToEvaluatorManual: string | URL,
  filename: string
): string {
  const base = String(urlToEvaluatorManual).replace(/\/?$/, '/');
  return base + filename;
}
